
import { requester } from "App";
import Dummy from "components/Dummy";
import P from "components/P";
import BackButton from "components/buttons/BackButton";
import CustomButton from "components/buttons/CustomButton";
import CustomIcon from "components/icons/CustomIcon";
import QuillViewer from "components/inputs/richEditor/QuillViewer";
import InputNumber from "components/inputs/signUp/InputNumber";
import Container from "layouts/container/Container";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import VerticalFlex from "layouts/flex/VerticalFlex";
import Center from "layouts/wrapper/Center";
import { AuthContext } from "providers/AuthProvider";
import { useContext, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { CartReducer } from "shared/redux/reducers/shopping/CartReducer";
import { decode } from "shared/utils/Utils";

function PuffuOrderProductDetail() {
    const location = useLocation();
    const [product, setProduct] = useState();
    const dispatch = useDispatch();
    const { id, productId } = useParams();
    const navigate = useNavigate();
    const { userName } = useContext(AuthContext);
    const cartData = useSelector((state) => state.cart.products);


    const quantityRef = useRef();
    useEffect(() => {
        if (location) {
            setProduct(location.state.data);
        }
    }, [location])

    const btnStyle = {
        backgroundColor: "var(--main-color)",
        border: "none"
    }

    const updateProductQuantity = (quantity) => {
        setProduct((prevProduct) => ({
            ...prevProduct,
            quantity
        }));
    };
    const onAddCartClick = () => {
        if (userName) {
            if (quantityRef.current.getValue() > 0) {
                dispatch(CartReducer.actions.addProductToCart({ ...product, quantity: quantityRef.current.getValue() }));
                toast.success(`장바구니에 추가되었습니다.`, {
                    autoClose: 1000,
                    position: toast.POSITION.BOTTOM_CENTER
                });
            } else {
                toast.error(`장바구니 수량을 선택해주세요.`, {
                    autoClose: 1000,
                    position: toast.POSITION.BOTTOM_CENTER
                });
            }
        } else {
            toast.error(`로그인하세요.`, {
                autoClose: 1000,
                position: toast.POSITION.BOTTOM_CENTER
            });
        }




    }
    const orderClick = () => {
        if (userName) {
            if (quantityRef.current.getValue() > 0) {
                onPaymentClick();
                // navigate(`/ws/${id}/homepage/orderSummary/${productId}`, { state: { product: product, quantity: quantityRef.current.getValue() } }, { replace: true });
            } else {
                toast.error(`수량을 선택해주세요.`, {
                    autoClose: 1000,
                    position: toast.POSITION.BOTTOM_CENTER
                });
            }
        } else {
            toast.error(`로그인하세요.`, {
                autoClose: 1000,
                position: toast.POSITION.BOTTOM_CENTER
            });
        }


    }
    const onCartClick = () => {
        navigate(`/ws/${id}/mobile/cart`);
    }



    const onPaymentClick = () => {
        const newTotal = product && product.price *quantityRef.current.getValue();
        const updatedProduct = {
            ...product,
            quantity: quantityRef.current.getValue()
        };
        const extractedData = {
            locationNo: product && product.locationNo,
            quantity: quantityRef.current.getValue(),

        };
        // 
        // // const extractedValues = extractedData.map(item => [item.locationNo, item.quantity]);
        const extractedValues = [[product && product.locationNo,quantityRef.current.getValue()]]
        // 

        
        const jsonMachineData = extractedValues;
        const jsonMachineString = JSON.stringify(jsonMachineData);
        const base64EncodedString = btoa(jsonMachineString);
        
        
        

        let data = {
            orderProducts: [updatedProduct],
            amount: newTotal,
            storeCode: id,
            machineData: base64EncodedString,
            returnUrl: 'https://puffuapp.com/ws/5/mobile'
        };

        // requester.purchaseOrder를 프로미스로 감싸기
        if (cartData && cartData.length > 0) {

            requester.testPaymentRequest(data, (result) => {

                if (result.code === 0) {

                    let ready = result.data;
                    requester.testPayment(ready, (result) => {
                        if (result.code === 0) {
                            let paymentResult = result.data;

                            const trxId = paymentResult.link.trxId;
                            const trackId = paymentResult.link.trackId;
                            const amount = paymentResult.link.amount;
                            const storeCode = paymentResult.link.udf1;
                            const deviceCode = window.BRIDGE && window.BRIDGE.getDeviceCode ? window.BRIDGE.getDeviceCode() : "";


                            const extractedData = {
                                locationNo: product && product.locationNo,
                                quantity: quantityRef.current.getValue(),
                    
                            };
                            const extractedValues = [[product && product.locationNo,quantityRef.current.getValue()]]
                            
                            const jsonData = extractedValues;
                            const jsonString = JSON.stringify(jsonData);
                            const base64EncodedString = btoa(jsonString);
                            const param = `data=${base64EncodedString}`;
                            navigate(`/ws/${id}/payment/puffuOrder?${param}&trxId=${trxId}&trackId=${trackId}&amount=${amount}&storeCode=${storeCode}&deviceCode=${deviceCode}`);
                        }
                    })
                } else {
                    toast.error("문제가 발생했습니다 관리자에게 문의하세요", {
                        autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
                    });
                }
            })

        } else {
            toast.error("장바구니에 물건이 없습니다.", {
                autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
            });
        }

    }

    return (
        <Container maxWidth={1200}>
            <Dummy height={"80px"} />
            <div
                style={{
                    position: "fixed",
                    top: 0,
                    zIndex: 99,
                    width: "100%",
                    height: "50px",
                    backgroundColor: "#F0F1F3"
                }}
            >
                <div style={{ width: "90%", margin: "0 auto", height: "50px" }}>
                    <HorizontalFlex>
                        <FlexChild width={"max-content"}>
                            <BackButton alignItems={"flex-start"} />
                        </FlexChild>
                        <FlexChild justifyContent={"center"}>
                            <P size={20} weight={700} font={"Pretendard"}>푸푸오더</P>

                        </FlexChild>
                        <FlexChild width={"max-content"}>
                            <div style={{ position: "relative" }} onClick={onCartClick}>
                                <div style={{
                                    position: "fixed",
                                    top: "10px",
                                    right: "12px",
                                    backgroundColor: "var(--point-color)",
                                    width: "14px",
                                    height: "14px",
                                    borderRadius: "50%",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    zIndex: 100
                                }}>
                                    <P color={"white"} size={10}>{cartData ? cartData.length : 0}</P>
                                </div>
                                <CustomIcon name={"statisticsCart"} width={"20px"} />
                            </div>
                        </FlexChild>

                    </HorizontalFlex>
                </div>
            </div>
            <VerticalFlex gap={15}>
                <FlexChild>
                    <HorizontalFlex>
                        <FlexChild width={"30%"}>
                            {/* <div style={{border: "1px solid black"}}> */}
                            <img src={product && product.productImg} width={"100%"} />
                            {/* </div> */}
                        </FlexChild>
                        <FlexChild>
                            <VerticalFlex flexStart gap={15}>
                                <FlexChild>
                                    <Center width={"100%"} textAlign={"left"}>
                                        <P weight={"bold"} size={"min(3.2vw, 30px)"}>{product && product.productName}</P>
                                        <P weight={"bold"} size={"min(2.8vw, 25px)"}>\ {product ? product.price.toLocaleString() : 0}</P>
                                    </Center>
                                </FlexChild>
                                <FlexChild width={"40%"}>
                                    <InputNumber ref={quantityRef} />
                                </FlexChild>
                                <FlexChild>
                                    <HorizontalFlex gap={20}>
                                        <FlexChild width={"max-content"}>
                                            <CustomButton text={"구매하기"} style={btnStyle} onClick={orderClick} />
                                        </FlexChild>
                                        <FlexChild>
                                            <CustomButton text={"장바구니"} onClick={onAddCartClick} />
                                        </FlexChild>
                                    </HorizontalFlex>
                                </FlexChild>
                            </VerticalFlex>

                        </FlexChild>

                    </HorizontalFlex>
                </FlexChild>
                <FlexChild height={"1px"} backgroundColor={"black"} />
                <FlexChild>
                    {

                        product && product.productDetailImg.startsWith("PHA")
                            ?
                            <div style={{ maxWidth: "1200px", height: '100%', overflowY: 'visible' }}>
                                <QuillViewer value={decode(product && product.productDetailImg)} />
                            </div>
                            :
                            <img src={product && product.productDetailImg} width={"100%"} />
                    }
                </FlexChild>
            </VerticalFlex>
        </Container>
    );
}

export default PuffuOrderProductDetail;